<template>
    <ui-button class="buy-btn dark-grey" :loading="loading" @click.capture.stop="buy"><i class="ti-cart"></i></ui-button>
</template>

<script lang="ts" setup>
import { useCartStore } from '~~/store/cartStore';

const props = defineProps<{
    id: number,
}>();

const emits = defineEmits<{
    buy: []
}>();


const cartStore = useCartStore();

const loading = ref(false);

async function buy() {

    if (loading.value) {
        return;
    }

    loading.value = true;

    try {
        await cartStore.buy(props.id);
        emits('buy')
    } catch {
        
    } finally {
        loading.value = false;
    }
}

</script>

<style lang="scss" scoped>
@use 'sass:color';
@use '~/assets/css/colors.scss' as *;


.buy-btn {
    width: 32px;
    height: 32px;
    padding: 0;
    font-size: 18px;

    border-radius: 50%;
    .loader-showbox {
        background: white;
        --color: #{$color-grey-dark};
    }
}

</style>